// apiglobal scope
import * as typedrequestInterfaces from '@api.global/typedrequest-interfaces';

export { typedrequestInterfaces };

// pushrocks scope
import * as isounique from '@push.rocks/isounique';
import * as lik from '@push.rocks/lik';
import * as smartenv from '@push.rocks/smartenv';
import * as smartjson from '@push.rocks/smartjson';
import * as smartlog from '@push.rocks/smartlog';
import * as smartdelay from '@push.rocks/smartdelay';
import * as smartpromise from '@push.rocks/smartpromise';
import * as smarttime from '@push.rocks/smarttime';
import * as smartrx from '@push.rocks/smartrx';

export {
  isounique,
  lik,
  smartenv,
  smartjson,
  smartlog,
  smartdelay,
  smartpromise,
  smarttime,
  smartrx,
};
